var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedBoxIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 19.6667L17.7621 22.8808C17.8496 22.9245 17.8933 22.9464 17.9392 22.955C17.9798 22.9626 18.0215 22.9626 18.0621 22.955C18.108 22.9464 18.1517 22.9245 18.2392 22.8808L24.6673 19.6667M11.334 16.3334L17.7621 13.1193C17.8496 13.0756 17.8933 13.0537 17.9392 13.0451C17.9798 13.0375 18.0215 13.0375 18.0621 13.0451C18.108 13.0537 18.1517 13.0756 18.2392 13.1193L24.6673 16.3334L18.2392 19.5474C18.1517 19.5912 18.108 19.613 18.0621 19.6216C18.0215 19.6293 17.9798 19.6293 17.9392 19.6216C17.8933 19.613 17.8496 19.5912 17.7621 19.5474L11.334 16.3334Z",
    stroke: "#445FD2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F3F6F9",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBoxIcon);
export default __webpack_public_path__ + "static/media/CheckedBoxIcon.3e1d4986f32d62b18fdb8651d43464f2.svg";
export { ForwardRef as ReactComponent };